import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { motion } from 'framer-motion';

const Privacy = () => {
  return (
    <div className="min-h-screen bg-background py-12 px-6">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.4 }}
        className="max-w-3xl mx-auto"
      >
        <Link
          to="/"
          className="inline-flex items-center text-sm text-muted-foreground hover:text-foreground mb-8"
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back to Home
        </Link>

        <div className="bg-card rounded-xl border border-border/50 shadow-lg p-8 md:p-12">
          <h1 className="text-3xl font-bold tracking-tight mb-8" data-testid="privacy-title">
            Privacy Policy – Nysa
          </h1>

          <div className="prose prose-gray max-w-none space-y-6">
            <p className="text-muted-foreground leading-relaxed">
              Nysa respects your privacy and is committed to protecting your information.
            </p>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Information We Collect</h2>
              <p className="text-muted-foreground leading-relaxed">
                When users create an account we collect basic information such as name and email address.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Platform Data</h2>
              <p className="text-muted-foreground leading-relaxed">
                Users may submit venue details and sensory accessibility information through the platform.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Payments</h2>
              <p className="text-muted-foreground leading-relaxed">
                Payments are processed securely through Stripe. Nysa does not store payment card details.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Emails</h2>
              <p className="text-muted-foreground leading-relaxed">
                We use Resend to send system emails such as account confirmations, password resets and submission notifications.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">How We Use Data</h2>
              <p className="text-muted-foreground leading-relaxed">
                Information collected is used only to operate and improve the Nysa platform and to communicate important account and service updates.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Data Security</h2>
              <p className="text-muted-foreground leading-relaxed">
                We implement reasonable safeguards to protect user information and platform data.
              </p>
            </section>

            <section className="space-y-3">
              <h2 className="text-xl font-semibold text-foreground">Contact</h2>
              <p className="text-muted-foreground leading-relaxed">
                <a href="mailto:privacy@nysa.org.uk" className="text-primary hover:underline">
                  privacy@nysa.org.uk
                </a>
              </p>
            </section>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default Privacy;
